import React from 'react';
import { EditorActions } from 'app/stores/editor/actions';
import { ProjectActions } from 'app/stores/project/actions';
import { getSelectedMarkersAlias } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { useConnect } from 'app/views/hooks/useConnect';
import { useItemSelector } from 'app/views/hooks/useItemSelector';
import { useKeyMove } from 'app/views/hooks/useKeyMove';
import { useTextEditor } from 'app/views/hooks/useTextEditor';
import { MarkerEdit } from './MarkerEdit';
import { MarkerInsert } from './MarkerInsert';
export const Interaction = () => {
    const dispatch = useAppDispatch();
    const ref = React.useRef(null);
    const stateProps = useConnect((state) => ({
        activeTool: state.editor.activeTool,
        selectedAlias: getSelectedMarkersAlias(state),
    }));
    const { activeTool, selectedAlias } = stateProps;
    // -----------------------
    // Item selection and drag
    // -----------------------
    const [setSelectorNode] = useItemSelector();
    // -----------------------
    // Doubl-tap to edit text
    // -----------------------
    const [setTextEditorNode] = useTextEditor();
    // -----------------------
    // Keyboard arrows to move selection
    // -----------------------
    useKeyMove({ active: true });
    React.useEffect(() => {
        const onKeyDown = (evt) => {
            switch (evt.key) {
                case 'Escape':
                    if (selectedAlias) {
                        dispatch(ProjectActions.clearSelection());
                    }
                    else if (activeTool) {
                        dispatch(EditorActions.clearTool());
                    }
                    break;
                default:
                    break;
            }
        };
        document.addEventListener('keydown', onKeyDown, true);
        return () => document.removeEventListener('keydown', onKeyDown, true);
    }, [activeTool, selectedAlias, dispatch]);
    const setRef = React.useCallback((node) => {
        setSelectorNode(node);
        setTextEditorNode(node);
        ref.current = node;
    }, [setSelectorNode, setTextEditorNode]);
    return (React.createElement("div", { className: "interactions-wrapper user-select-none touch-action-none", "data-test-id": "interactions", ref: setRef },
        activeTool && React.createElement(MarkerInsert, null),
        selectedAlias && React.createElement(MarkerEdit, null)));
};
